import React from 'react';
import styles from './Stars.module.scss';

interface Props {
  amount: number;
}

const getCssDataSize = (amount: number): 'quarter' | 'half' | 'three-quarter' => {
  const decimalPart = amount % 1;
  switch (true) {
    case decimalPart <= 0.25:
      return 'quarter';
    case decimalPart <= 0.5:
      return 'half';
    default:
      return 'three-quarter';
  }
};

export const Stars: React.FC<Props> = ({ amount }) => {
  return (
    <>
      {Array.from({ length: 5 }).map((_, i) => {
        switch (true) {
          case i + 1 > amount && i + 1 === Math.ceil(amount):
            return (
              <span className={styles.halfStyle} key={i} data-char="★" data-size={getCssDataSize(amount)}>
                ☆
              </span>
            );
          case i + 1 > amount:
            return <span key={i}>☆</span>;
          default:
            return <span key={i}>★</span>;
        }
      })}
    </>
  );
};

export default Stars;
